var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, { viewBox: '0 0 20 16' }, props), React.createElement('path', {
        fill: '#ffffff',
        d: 'M 19.96 1.88 C 19.22 2.2 18.43 2.41 17.6 2.51 C 18.45 2.01 19.1 1.23 19.4 0.29 C 18.61 0.75 17.74 1.09 16.8 1.27 C 16.06 0.49 14.99 0 13.82 0 C 11.55 0 9.72 1.79 9.72 4.01 C 9.72 4.32 9.76 4.63 9.83 4.92 C 6.43 4.75 3.41 3.16 1.39 0.73 C 1.04 1.32 0.83 2.01 0.83 2.75 C 0.83 4.14 1.56 5.36 2.66 6.08 C 1.99 6.06 1.35 5.88 0.8 5.58 C 0.8 5.6 0.8 5.61 0.8 5.63 C 0.8 7.57 2.21 9.19 4.09 9.56 C 3.74 9.65 3.38 9.7 3.01 9.7 C 2.74 9.7 2.49 9.68 2.24 9.63 C 2.76 11.22 4.27 12.38 6.06 12.41 C 4.66 13.49 2.89 14.13 0.98 14.13 C 0.65 14.13 0.32 14.11 0 14.07 C 1.81 15.21 3.96 15.87 6.28 15.87 C 13.81 15.87 17.92 9.77 17.92 4.47 C 17.92 4.3 17.92 4.12 17.91 3.95 C 18.71 3.39 19.41 2.68 19.96 1.88'
    }));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Twitter.svg
// module id = 535
// module chunks = 1